import template from './checklistEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor(
      $mdDialog,
      $mdMedia,
      eventService,
      checklistService,
      uiService,
      Checklist,
      ChecklistItem
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onChecklistEdit((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                checklist: params.checklist
                  ? angular.copy(params.checklist)
                  : Checklist.blank(),
                isMedia: ctrl.mdMedia
              },
              template,
              controllerAs: '$ctrl',
              controller(checklist, isMedia) {
                const ctr = this;
                ctr.checklist = checklist;
                ctr.IsMedia = isMedia;
                ctr.item = null;
                ctr.defaultItemDue =
                  ctr.checklist && ctr.checklist.items && ctr.checklist.items.length
                    ? ctr.checklist.items[0].due
                    : 7;
                ctr.isEditingChecklist = _.isUuid(checklist.id);
                ctr.pickIcon = false;
                ctr.iconPicked = (icon) => {
                  ctr.pickIcon = false;
                  ctr.checklist.icon = icon;
                };
                ctr.itemAdd = () => {
                  const newChecklistItem = ChecklistItem.blank();
                  newChecklistItem.due = ctr.defaultItemDue;
                  ctr.checklist.items.push(newChecklistItem);
                };
                ctr.itemRemove = (index) => {
                  ctr.checklist.items.splice(index, 1);
                };
                ctr.modifyDueItems = () => {
                  const len = ctr.checklist.items.length;
                  for (let i = 0; i < len; i += 1) {
                    ctr.checklist.items[i].due = ctr.defaultItemDue;
                  }
                };
                ctr.confirm = () => {
                  if (ctr.checklist.name !== '') {
                    $mdDialog.hide(ctr.checklist);
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'Checklist',
                        p2: 'name',
                        p3: 'is required'
                      },
                      warn: true
                    });
                  }
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              const checklist = result;
              if (!_.isUuid(checklist.id)) {
                checklistService.createChecklist(checklist).then((data) => {
                  if (data.status) {
                    checklist.id = data.id;
                    checklist.isNew = true;
                    ctrl.onFinished({ checklist });
                    uiService.toast({
                      text: {
                        p1: 'Checklist',
                        p2: checklist.getName(),
                        p3: 'has been added'
                      }
                    });
                  }
                });
              } else {
                checklistService.updateChecklist(checklist).then((data) => {
                  if (data.status) {
                    ctrl.onFinished({ checklist });
                    uiService.toast({
                      text: {
                        p1: 'Checklist',
                        p2: checklist.getName(),
                        p3: 'has been updated'
                      }
                    });
                  }
                });
              }
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
